export const gapSizes = {
  0: '0.5rem',
  // 8px
  1: '0.75rem',
  // 12px
  2: '1rem',
  // 16px
  3: '1.5rem',
  // 24px
  4: '2rem' // 32px
};